// This icon file is generated automatically.
var PtoSendOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 32 32", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M29.1 15.6L2.98 2.47a.5.5 0 00-.7.57l2.68 11c.04.17.16.3.33.36l4.61 1.58-4.61 1.59a.49.49 0 00-.32.35l-2.7 11.02a.5.5 0 00.7.57l26.15-13.03c.1-.05.17-.13.22-.22a.5.5 0 00-.22-.68zM5.35 25.81L6.9 19.4l9.22-3.17a.25.25 0 000-.47l-9.22-3.17-1.57-6.4 19.63 9.84-19.63 9.8z", "fill-rule": "nonzero" } }] }, "name": "pto-send", "theme": "outlined" };
export default PtoSendOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PtoSendOutlined.js
// module id = 3931
// module chunks = 0